export default "__VITE_ASSET___lIbnD2$__"